module.exports = __webpack_public_path__ + "static/lframe-kiwibank-debt-consolidation-57868baad515a250941dd4af56663197.webp";